<!-- resources/js/components/SwiperVueComponent.vue -->
<template>
    <div class="container">
        <div class="slider__content">
            <div class="swiper services__slider">
                <div class="swiper-wrapper">
                    <a  v-for="slide in sliders" :key="slide.id"  :href="'https://' + slide.link" target="_blank" class="swiper-slide">
                        <div class="links-section__item">
                            <span class="site__name">{{  slide.title }}</span>
                            <div class="d-flex">
                                <img src="https://sosial.gov.az/images/svg-icons/link.svg" class="links__icon" width="20" height="20" alt="site link">
                                <span class="site__name site__link">{{  slide.site }}</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="swiper-button-prev custom__arrows services__slider__button services__slider__button__prev"></div>
                <div class="swiper-button-next custom__arrows services__slider__button services__slider__button__next"></div>
            </div>
        </div>
    </div>
</template>

<script>

import './assets/swiper-bundle.js';
import http from "../../helper/http-common";


export default {
    name: "Swiper",
    props: {
        apiLink: {
            type: String,
            required: true
        },
        ssl: Boolean
    },

    data(){
      return {
          sliders : []
      }
    },

    created() {
        const cachedData = localStorage.getItem('sliderData');
        if (cachedData) {
            this.sliders = JSON.parse(cachedData);
        } else {
            this.fetchDataAndCache();
        }
    },
    mounted() {

         console.log("comp mounted...." + " " + this.apiLink)
        let A = new Swiper(".services__slider",
                {
                    autoplay:true,
                    autoplay: {
                        delay: 3000,
                    },
                    loop:true,
                    spaceBetween:24,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 1,
                            autoplay:true,
                            autoplay: {
                                delay: 3000,
                            },
                        },
                        // when window width is >= 767px
                        767: {
                            slidesPerView: 2,
                            autoplay:true,
                            autoplay: {
                                delay: 3000,
                            },
                        },
                        // when window width is >= 1024px
                        1024: {
                            slidesPerView: 4,
                            autoplay:true,
                            autoplay: {
                                delay: 3000,
                            }
                        }
                    },
                });

    },

    methods: {
        fetchDataAndCache() {
            http.get(this.apiUrl).then((response) => {
                this.sliders = response.data.data;
                localStorage.setItem('sliderData', JSON.stringify(response.data.data));
                this.setClearLocalStorageTimer();
            });
        },
        setClearLocalStorageTimer() {
            setTimeout(() => {
                localStorage.removeItem('sliderData');
            }, 2 * 60 * 1000); // Clear localStorage after 2 minutes
        }
    },
    computed: {
        apiUrl() {
            const protocol = this.ssl ? 'https' : 'http';
            //return `${protocol}://${this.apiLink}/qurumlar.json`;
            return `${protocol}://${this.apiLink}`;
        }
    }
};
</script>

<style scoped>
/* Your component styles here */
</style>
